var image_viewer_rtlignore_default = {
  "fontElementMap": "haqlz",
  "imageContainer": "wpSEk",
  "expandButton": "cCu1k",
  "expandIcon": "QKqtg",
  "pointer": "zogKv",
  "imageWrapper": "_5aKNl",
  "imageRatio": "OR89a",
  "image": "eRIeI",
  "imageOverlay": "y9gFq",
  "imagePreload": "CfE7k",
  "imageHighres": "S-vHS",
  "onlyHighRes": "-WYPK",
  "image_loading": "_6s6Tr"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
